/** Enum representing common status code responses from API requests. */
export enum HttpStatusCode {
  Accepted = 202,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500
}
